import React from 'react';
import { Link } from 'react-router-dom';
import { getPathWithParams } from '../../../helpers/router';
import { businessRoutes } from '../../../utils/routes';

import iconFb from '../../assets/footer/ic-fcb.svg';
import iconIn from '../../assets/footer/ic-link.svg';
import Animate from '../Animate';

function Footer({ t, language }) {
	return (
		<div className="landing-container-footer">
			<div className="landing-layout">
				<div className="landing-page-footer">
					<div className="landing-footer-container">
						<div className="landing-footer-container-header">
							<Animate>
								<h2>{t("landing.footer.title")}</h2>
							</Animate>
							<p>{t("landing.footer.paragraph")}</p>
						</div>
						<div className="landing-footer-container-button">
							<Link
								className="landing-animated button-red"
								to={getPathWithParams({
									path: businessRoutes.register,
									params: { language },
								})}
							>
								{t("landing.footer.button")}
							</Link>
						</div>
					</div>
					<footer>
						<div className="landing-footer-line"></div>
						<div className="landing-footer-nav">
							<div className="landing-footer-nav-text">
								<span>{t("landing.footer.openfield")}</span>
								<a
									href={
										process.env.PUBLIC_URL +
										`/pdf/${t("landing.common.pdf.regulation")}.pdf`
									}
									target="_blank"
									rel="noopener noreferrer"
								>
									<span>{t("landing.footer.regulamin")}</span>
								</a>
							</div>
							<div className="landing-footer-nav-social">
								<a
									href="https://www.facebook.com/OpenfieldPL/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={iconFb} alt="logo" />
								</a>
								<a
									href="https://www.linkedin.com/company/openfieldpl/about/"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img src={iconIn} alt="logo" />
								</a>
							</div>
						</div>
					</footer>
				</div>
			</div>
		</div>
	);
}

export default Footer;
